module.exports = __webpack_public_path__ + "public/images/program/program-20.b006ae6c7dccf8caffe053cda918fd28.jpeg";